import './header.scss';
import gameCollection from '../gameCollection.json';

let nickname;

let languageControl = Array.from(document.querySelectorAll('.lang-control'));
let themeControl = Array.from(document.querySelectorAll('.theme-control'));
let nicknamesArray = Array.from(document.querySelectorAll('.user__nickname'));
let settingsIcon = document.querySelector('.settings__icon');
let settingsList = document.querySelector('.settings__list');
let navListIcon = document.querySelector('.nav-list__hamburger-icon');
let navList = document.querySelector('.hamburger-menu');
let userAvatarArray = Array.from(document.querySelectorAll('.user__avatar'));
let userImagesListArray = Array.from(document.querySelectorAll('.user__images'));
let userImagesArray = Array.from(document.querySelectorAll('.user-image'));

window.addEventListener('beforeunload', () => {
  if (nickname) {
    localStorage.setItem('nickname', nickname);
  }

  localStorage.setItem('avatarSrc', userAvatarArray[0].src)

})

window.addEventListener('load', () => {
  if (localStorage.getItem('nickname')) {
    nickname = localStorage.getItem('nickname');
    actualizeNickname();
  }

  if (localStorage.getItem('avatarSrc')) {
    userAvatarArray[0].src = localStorage.getItem('avatarSrc');
    userAvatarArray[1].src = localStorage.getItem('avatarSrc');
  }
})

nicknamesArray.forEach(e => {
  e.addEventListener('input', () => {
    nickname = e.value;

    actualizeNickname();
  })
})

function actualizeNickname() {
  if (nickname) {
    nicknamesArray.forEach(e => {
      e.value = nickname;
    })
  }
}

settingsIcon.addEventListener('click', () => {
  settingsList.classList.toggle('settings__list_active');
})

document.addEventListener('click', e => {
  let settingsIconBoundaries = e.composedPath().includes(settingsIcon);
  let settingsListBoundaries = e.composedPath().includes(settingsList);

  if (!settingsIconBoundaries && !settingsListBoundaries) {
    settingsList.classList.remove('settings__list_active');
  }
})

navListIcon.addEventListener('click', () => {
  navList.classList.toggle('hamburger-menu_active');
})

document.addEventListener('click', e => {
  let navIconBoundaries = e.composedPath().includes(navListIcon);
  let navListBoundaries = e.composedPath().includes(navList);

  if (!navIconBoundaries && !navListBoundaries) {
    navList.classList.remove('hamburger-menu_active');
  }
})

userAvatarArray.forEach(e => {
  e.addEventListener('click', () => {
    userImagesListArray.forEach(el => {
      el.classList.toggle('user__images_active');
    })
  })
})

document.addEventListener('click', e => {
  let usersImagesBoundaries1 = e.composedPath().includes(userImagesListArray[0]);
  let usersImagesBoundaries2 = e.composedPath().includes(userImagesListArray[1]);
  let userAvatarBoundaries1 = e.composedPath().includes(userAvatarArray[0]);
  let userAvatarBoundaries2 = e.composedPath().includes(userAvatarArray[1]);

  if (!usersImagesBoundaries1 && !userAvatarBoundaries1 && !usersImagesBoundaries2 && !userAvatarBoundaries2) {
    userImagesListArray.forEach(el => {
      el.classList.remove('user__images_active');
    })
  }
})

userImagesArray.forEach(e => {
  e.addEventListener('click', () => {
    userAvatarArray[0].src = e.src;
    userAvatarArray[1].src = e.src;
  })
})

class HeaderControls {
  constructor(lang, theme, volume) {
    this.lang = lang;
    this.theme = theme;
    this.volume = volume;
  }

  languageChanger() {
    if (localStorage.getItem('language') !== 'undefined') {
      this.lang = localStorage.getItem('language');
    }


    if (this.lang === 'en') {
      let documentElementsArray = Array.from(document.body.querySelectorAll('[class*=_lang_ru]'));
      documentElementsArray.forEach(el => {
        if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
          el.className = el.className.replace('_lang_ru', '_lang_en');
        } else {
          el.className.baseVal = el.className.baseVal.replace('_lang_ru', '_lang_en');
        }
      })

    } else {
      let documentElementsArray = Array.from(document.body.querySelectorAll('[class*=_lang_en]'));
      documentElementsArray.forEach(el => {
        if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
          el.className = el.className.replace('_lang_en', '_lang_ru');
        } else {
          el.className.baseVal = el.className.baseVal.replace('_lang_en', '_lang_ru');
        }
      })
    }

    languageControl.forEach(e => {
      e.addEventListener('click', () => {
        if (this.lang === 'ru') {
          let documentElementsArray = Array.from(document.body.querySelectorAll('[class*=_lang_ru]'));
          documentElementsArray.forEach(el => {
            if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
              el.className = el.className.replace('_lang_ru', '_lang_en');
            } else {
              el.className.baseVal = el.className.baseVal.replace('_lang_ru', '_lang_en');
            }
          })

          this.lang = 'en';

        } else {
          let documentElementsArray = Array.from(document.body.querySelectorAll('[class*=_lang_en]'));
          documentElementsArray.forEach(el => {
            if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
              el.className = el.className.replace('_lang_en', '_lang_ru');
            } else {
              el.className.baseVal = el.className.baseVal.replace('_lang_en', '_lang_ru');
            }
          })

          this.lang = 'ru';
        }

        if (document.querySelector('.collection-section')) {
          let informationArray = [];

          for (let key in gameCollection) {
            for (let i = 0; i < gameCollection[key].length; i++) {
              if (this.lang === 'ru') {
                informationArray.push(gameCollection[key][i].description_ru);
              } else {
                informationArray.push(gameCollection[key][i].description_en);
              }
            }
          }

          Array.from(document.querySelectorAll('.information__description')).forEach((e, i) => {
            e.textContent = informationArray.shift();
          })
        }
      })
    })
  }

  themeChanger() {
    if (localStorage.getItem('theme') !== 'undefined') {
      this.theme = localStorage.getItem('theme');
    }

    if (this.theme === 'light') {
      let documentElementsArray = Array.from(document.querySelectorAll('[class*=_dark]'));
      documentElementsArray.forEach(el => {
        if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
          el.className = el.className.replace('_dark', '_light');
        } else {
          el.className.baseVal = el.className.baseVal.replace('_dark', '_light');
        }
      })
      this.volumeSlidersActualize();
    } else {
      let documentElementsArray = Array.from(document.querySelectorAll('[class*=_light]'));
      documentElementsArray.forEach(el => {
        if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
          el.className = el.className.replace('_light', '_dark');
        } else {
          el.className.baseVal = el.className.baseVal.replace('_light', '_dark');
        }
      })
      this.volumeSlidersActualize();
    }

    themeControl.forEach(e => {
      e.addEventListener('click', () => {
        if (this.theme === 'dark') {
          let documentElementsArray = Array.from(document.querySelectorAll('[class*=_dark]'));
          documentElementsArray.forEach(el => {
            if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
              el.className = el.className.replace('_dark', '_light');
            } else {
              el.className.baseVal = el.className.baseVal.replace('_dark', '_light');
            }
          })
          this.theme = 'light';
          this.volumeSlidersActualize();
        } else {
          let documentElementsArray = Array.from(document.querySelectorAll('[class*=_light]'));
          documentElementsArray.forEach(el => {
            if (el.tagName !== 'svg' && el.tagName !== 'g' && el.tagName !== 'path') {
              el.className = el.className.replace('_light', '_dark');
            } else {
              el.className.baseVal = el.className.baseVal.replace('_light', '_dark');
            }
          })
          this.theme = 'dark';
          this.volumeSlidersActualize();
        }
      })
    })
  }

  volumeControl(isFirst = false) {
    let volumeControlArray = Array.from(document.querySelectorAll('.volume-control'));
    let volumeSliderArray = Array.from(document.querySelectorAll('.volume-slider'));
    let volumeSliderRangeArray = Array.from(document.querySelectorAll('.volume-slider__range'));
    let volumeIconsArray = Array.from(document.querySelectorAll('.volume-control__icon'));

    volumeControlArray.forEach(e => {
      e.addEventListener('mouseover', () => {
        e.querySelector('.volume-slider').classList.add('volume-slider_active');
      })
    })

    volumeSliderArray.forEach(e => {
      e.addEventListener('mouseleave', () => {
        e.classList.remove('volume-slider_active');
      })
    })

    volumeIconsArray.forEach((e, i) => {
      if (isFirst === true || (i !== 0 && i !== 1)) {
        e.addEventListener('click', (event) => {
          if (e.classList.contains('volume-control__icon_mute')) {
            if (i === 0 || i === 1) {
              volumeSliderRangeArray[0].value = 30;
              volumeSliderRangeArray[1].value = 30;
              volumeIconsArray[1].classList.remove('volume-control__icon_mute');
              volumeIconsArray[1].classList.add('volume-control__icon_low');
              volumeIconsArray[0].classList.remove('volume-control__icon_mute');
              volumeIconsArray[0].classList.add('volume-control__icon_low');
              this.volumeSliderActualize(volumeSliderRangeArray[0]);
              this.volumeSliderActualize(volumeSliderRangeArray[1]);
            }
  
            volumeSliderRangeArray[i].value = 30;
            e.classList.remove('volume-control__icon_mute');
            e.classList.add('volume-control__icon_low');
  
          } else {
  
            if (i === 0 || i === 1) {
              volumeSliderRangeArray[1].value = 0;
              volumeIconsArray[1].classList.remove('volume-control__icon_low');
              volumeIconsArray[1].classList.remove('volume-control__icon_medium');
              volumeIconsArray[1].classList.remove('volume-control__icon_high');
              volumeIconsArray[1].classList.add('volume-control__icon_mute');
              this.volumeSliderActualize(volumeSliderRangeArray[1]);
  
              volumeSliderRangeArray[0].value = 0;
              volumeIconsArray[0].classList.remove('volume-control__icon_low');
              volumeIconsArray[0].classList.remove('volume-control__icon_medium');
              volumeIconsArray[0].classList.remove('volume-control__icon_high');
              volumeIconsArray[0].classList.add('volume-control__icon_mute');
              this.volumeSliderActualize(volumeSliderRangeArray[0]);
            }
  
            volumeSliderRangeArray[i].value = 0;
            e.classList.remove('volume-control__icon_low');
            e.classList.remove('volume-control__icon_medium');
            e.classList.remove('volume-control__icon_high');
            e.classList.add('volume-control__icon_mute');
          }
  
          this.volumeSliderActualize(volumeSliderRangeArray[i]);
          this.volumeActualize();
        })
      }
    })

    volumeSliderRangeArray.forEach((e, i) => {
      e.addEventListener('input', () => {
        clearVolumeIcons(volumeIconsArray[i]);
        setVolumeIcon(volumeIconsArray[i], e.value)
        this.volumeSliderActualize(e);
        this.volumeActualize();
      })
    })

    function clearVolumeIcons(element) {
      element.classList.remove('volume-control__icon_mute');
      element.classList.remove('volume-control__icon_low');
      element.classList.remove('volume-control__icon_medium');
      element.classList.remove('volume-control__icon_high');
    }

    function setVolumeIcon(element, volumeLevel) {
      switch (Math.ceil(volumeLevel / 40)) {
        case (0):
          element.classList.add('volume-control__icon_mute');
          break;

        case (1):
          element.classList.add('volume-control__icon_low');
          break;

        case (2):
          element.classList.add('volume-control__icon_medium');
          break;

        case (3):
          element.classList.add('volume-control__icon_high');
          break;
      }
    }
  }

  volumeActualize() {
    let audioArray = Array.from(document.querySelectorAll('audio'));
    let volumeSliderRangeArray = Array.from(document.querySelectorAll('.volume-slider__range'));
    this.volume = volumeSliderRangeArray[0].value;
    let mainVolumeСoefficient = this.volume / 100;
    for (let i = 2; i < volumeSliderRangeArray.length; i++) {
      audioArray[i - 2].volume = volumeSliderRangeArray[i].value / 100 * mainVolumeСoefficient;
    }

    if (document.querySelector('.game-section')) {
      document.querySelector('.correct-answer-audio').volume = mainVolumeСoefficient;
      document.querySelector('.wrong-answer-audio').volume = mainVolumeСoefficient;
    }
  }

  volumeSliderActualize(element) {
    if (this.theme === 'dark') {
      element.style.background = `-webkit-linear-gradient(left, #57d6ff 0%, #57d6ff ${element.value}%, #ffffff ${element.value}%, #ffffff 100%)`;
    } else {
      element.style.background = `-webkit-linear-gradient(left, #0443f2 0%, #0443f2 ${element.value}%, #0c243c ${element.value}%, #0c243c 100%)`;
    }
  }

  volumeSlidersActualize() {
    let volumeSliderRangeArray = Array.from(document.querySelectorAll('.volume-slider__range'));
    volumeSliderRangeArray.forEach(element => {
      if (this.theme === 'dark') {
        element.style.background = `-webkit-linear-gradient(left, #57d6ff 0%, #57d6ff ${element.value}%, #ffffff ${element.value}%, #ffffff 100%)`;
      } else {
        element.style.background = `-webkit-linear-gradient(left, #0443f2 0%, #0443f2 ${element.value}%, #0c243c ${element.value}%, #0c243c 100%)`;
      }
    })
    // for (let i = 0; i< volumeSliderRangeArray.length; i++) {

    // }
  }
}

export { HeaderControls };